/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Angular nos da `}<inlineCode parentName="p">{`*ngif`}</inlineCode>{` para que manejemos nuestros componentes condicionales y se utiliza de la siguiente manera.`}</p>
    <div {...{
      "className": "remark-highlight"
    }}><pre parentName="div" {...{
        "className": "language-jsx"
      }}><code parentName="pre" {...{
          "className": "language-jsx"
        }}><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`div`}</span>{` `}<span parentName="span" {...{
              "className": "token attr-name"
            }}>{`class`}</span><span parentName="span" {...{
              "className": "token attr-value"
            }}><span parentName="span" {...{
                "className": "token punctuation attr-equals"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`"`}</span>{`pokedex-screen`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`"`}</span></span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}></span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`  // Si hay un error, entonces...`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`  <img`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`    *ngIf="error"`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`    src="/assets/error.gif"`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`    alt="Hubo un error buscando tu pokemon"`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`    class="pokedex-no-screen"`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`  />`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`  // Si esta cargando y no hay un error, entonces...`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`  <img`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`    *ngIf="loading && !error;"`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`    src="/assets/loading.gif"`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`    alt="Aún no hay ningun pokemon"`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`    class="pokedex-no-screen"`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`  /> :`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`  // Si hay un pokemon y no está cargando, ni hay un error, entonces...`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`  <div class="pokemon-info" *ngIf="pokemon && !loading && !error">`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`    `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`h2`}</span>{` `}<span parentName="span" {...{
              "className": "token attr-name"
            }}>{`class`}</span><span parentName="span" {...{
              "className": "token attr-value"
            }}><span parentName="span" {...{
                "className": "token punctuation attr-equals"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`"`}</span>{`pokemon-name`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`"`}</span></span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`pokemon`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token property-access"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`h2`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}></span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`    <img class="pokemon-img" src=`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`pokemon`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token property-access"
          }}>{`sprites`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token property-access"
          }}>{`front_default`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{` alt=`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`pokemon`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token property-access"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`} />`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`    `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`ul`}</span>{` `}<span parentName="span" {...{
              "className": "token attr-name"
            }}>{`class`}</span><span parentName="span" {...{
              "className": "token attr-value"
            }}><span parentName="span" {...{
                "className": "token punctuation attr-equals"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`"`}</span>{`pokemon-stats`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`"`}</span></span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}></span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`      <li`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`        class="pokemon-stat"`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`        *ngFor="let item of pokemon.stats;"`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`      >`}</span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`        <app-stat [item]="item">`}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`app-stat`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}></span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`      `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`li`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}></span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`    `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`ul`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}></span>{`
`}<span parentName="code" {...{
            "className": "token plain-text"
          }}>{`  `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`div`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span>{`
`}<span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`div`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span>{`
`}</code></pre></div>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;